<div class="card suggestion-dialog">
  <div class="card-header">
    <span class="card-title">Assistant feedback and suggestions</span>
    <button mat-mini-fab class="closex" color="warn" type="button" (click)="dialogRef.close()" matTooltip="Close" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="card-body suggestion-dialog-body">
  <form class="suggestion-form" [formGroup]="suggestionForm" (ngSubmit)="submitSuggestion()">
    <mat-form-field appearance="outline">
      <mat-label>Suggested question</mat-label>
      <input matInput formControlName="question" maxlength="500" />
      <mat-error *ngIf="suggestionForm.get('question')?.hasError('required')">Question is required.</mat-error>
    </mat-form-field>
    <label class="editor-label">Expected answer or behavior</label>
    <quill-editor
      class="assistant-rich-editor"
      formControlName="expectedBehavior"
      [modules]="quillConfig"
      [sanitize]="true"
      placeholder="Describe the expected behavior, add formatted examples, or paste an image…"
    ></quill-editor>
    <div class="editor-error" *ngIf="suggestionForm.get('expectedBehavior')?.touched && suggestionForm.get('expectedBehavior')?.hasError('required')">Expected behavior is required.</div>
    <div class="editor-error" *ngIf="suggestionForm.get('expectedBehavior')?.hasError('maxlength')">The suggestion is too large. Remove or reduce an image and try again.</div>
    <mat-form-field appearance="outline">
      <mat-label>Example or reference (optional)</mat-label>
      <input matInput formControlName="exampleReference" maxlength="300" />
    </mat-form-field>
    <div class="form-actions">
      <button mat-flat-button color="primary" type="submit" [disabled]="submitting">
        <mat-icon>send</mat-icon>
        {{ submitting ? 'Submitting…' : 'Submit suggestion' }}
      </button>
    </div>
  </form>

  <div class="queue-header">
    <div>
      <h3>Review queue</h3>
      <span>{{ suggestions.length }} queue item(s)</span>
    </div>
    <div class="queue-actions">
      <button mat-icon-button type="button" (click)="copySuggestions()" [disabled]="!suggestions.length" matTooltip="Copy actionable feedback" aria-label="Copy actionable feedback">
        <mat-icon>content_copy</mat-icon>
      </button>
      <button mat-icon-button type="button" (click)="exportSuggestions('markdown')" [disabled]="!suggestions.length" matTooltip="Export Markdown" aria-label="Export Markdown">
        <mat-icon>description</mat-icon>
      </button>
      <button mat-icon-button type="button" (click)="exportSuggestions('json')" [disabled]="!suggestions.length" matTooltip="Export JSON" aria-label="Export JSON">
        <mat-icon>data_object</mat-icon>
      </button>
      <button mat-icon-button type="button" (click)="loadSuggestions()" [disabled]="loading" matTooltip="Refresh queue" aria-label="Refresh queue">
        <mat-icon>refresh</mat-icon>
      </button>
    </div>
  </div>

  <div class="dialog-message success" *ngIf="message">{{ message }}</div>
  <div class="dialog-message error" *ngIf="error">{{ error }}</div>
  <div class="queue-state" *ngIf="loading">Loading suggestions…</div>
  <div class="queue-state" *ngIf="!loading && !suggestions.length">No feedback or suggestions have been submitted.</div>

  <div class="suggestion-list" *ngIf="!loading && suggestions.length">
    <article class="suggestion-item" [class.incorrect-answer-item]="isIncorrectAnswer(suggestion)" *ngFor="let suggestion of suggestions">
      <div class="suggestion-heading">
        <div class="submission-type">
          <mat-icon>{{ isIncorrectAnswer(suggestion) ? 'thumb_down' : 'tips_and_updates' }}</mat-icon>
          <span>{{ isIncorrectAnswer(suggestion) ? 'Incorrect answer' : 'Question suggestion' }}</span>
        </div>
        <strong>#{{ suggestion.id }} · {{ suggestion.question }}</strong>
        <span>{{ suggestion.createdByName }} · {{ suggestion.createdOn | date:'medium' }}</span>
      </div>
      <div *ngIf="suggestion.assistantAnswer" class="reported-answer"><strong>Assistant answer:</strong> <span [innerHTML]="suggestion.assistantAnswer"></span></div>
      <div class="rich-feedback"><strong>{{ isIncorrectAnswer(suggestion) ? 'User feedback' : 'Expected' }}:</strong> <span [innerHTML]="suggestion.expectedBehavior"></span></div>
      <p *ngIf="suggestion.exampleReference"><strong>Reference:</strong> {{ suggestion.exampleReference }}</p>
      <div class="review-fields">
        <mat-form-field appearance="outline">
          <mat-label>Status</mat-label>
          <mat-select [(ngModel)]="suggestion.status" [ngModelOptions]="{standalone: true}">
            <mat-option *ngFor="let status of statuses" [value]="status.value">{{ status.label }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="notes-field">
          <mat-label>Developer notes</mat-label>
          <textarea matInput [(ngModel)]="suggestion.developerNotes" [ngModelOptions]="{standalone: true}" maxlength="2000" rows="2"></textarea>
        </mat-form-field>
        <button mat-stroked-button color="primary" type="button" (click)="saveSuggestion(suggestion)" [disabled]="savingID === suggestion.id">
          <mat-icon>save</mat-icon>
          {{ savingID === suggestion.id ? 'Saving…' : 'Save' }}
        </button>
      </div>
    </article>
  </div>
  </div>
</div>
